import React, {useState} from "react";
import {Badge, Button, Col, Input, Layout, notification, Row, Steps, Typography} from 'antd';
import {DefenderService} from "../../service/defender.service";
import {IfEqual} from "../../component/if.equal.component";
import {BranchesOutlined, EyeOutlined, RightOutlined, UploadOutlined, WifiOutlined} from '@ant-design/icons';

const { Header, Content, Footer } = Layout;

const { TextArea } = Input;

const svc = new DefenderService()
const PublicDefenderPage = () =>{
    const UTXO_SIZE_LIMIT = 10
    const [val, setVal] = useState("")
    const [isLoading, setLoading] = useState(false)
    const [currentStep, setCurrentStep] = useState(0)
    const [transactionID, setTransactionID] = useState('')

    const defend = ()=>{
        setTransactionID("")
        setLoading(true)
        let info: any = (window as any).transactionInfo?.(val) || {"error": "ruh oh"}
        if(info.error){
            setLoading(false)
            notification.error({
                message: 'Invalid Transaction Detected',
                description:
                    "You've entered an invalid transaction",
            });
            return
        }
        let tx: any = info.transaction;
        if(tx.totalInputs > UTXO_SIZE_LIMIT){
            setLoading(false)
            notification.error({
                message: 'Too Many UTXOs',
                description:
                    `The transaction you've entered references ${tx.totalInputs} UTXOs. You can only defend up to ${UTXO_SIZE_LIMIT} UTXOs`,
            });
            return;
        }
        setTransactionID(`https://mempool.space/testnet/tx/${tx.id}`)

        // TODO: move the following logic to the backend?
        // svc.validateTransaction(tx, true).then((valid)=>{
        //     if(!valid){
        //         notification.error({
        //             message: 'Spent Transaction Detected',
        //             description:
        //                 "You've entered a transaction that references an invalid or spent input",
        //         });
        //
        //         throw "ruh oh"
        //     }
        //     return svc.testNet(val)
        // })
        svc.testNet(val).then(()=>{
            notification.success({
                message: 'Transaction Defended',
                description:
                    "Your transaction is now defended",
            });
            setCurrentStep(1)
            setVal('')
        }).catch((e)=>{
            console.error(e)
            notification.error({
                message: 'Something went wrong',
                description:
                    "Verify that transaction is accurate and try again",
            });
        })
            .finally(()=>{
            setLoading(false)
        })
    }

    return (
            <Row>
                <Col md={16} xs={24} lg={16} style={{marginLeft: "auto", marginRight: "auto"}}>
                    <Badge.Ribbon placement={'start'} text="Testnet Defender">
                    <Content style={{background:'#fff', padding: 10, paddingTop: 50}}>
                        <Steps
                            current={currentStep}
                            style={{cursor: "pointer"}}>
                            <Steps.Step title={"Upload"} icon={<UploadOutlined />} onClick={()=>setCurrentStep(0)}/>
                            <Steps.Step title={"Attack"}
                                        disabled={!transactionID}
                                        icon={<WifiOutlined />} onClick={()=>transactionID && setCurrentStep(1)}/>
                            <Steps.Step title={"Verify"}
                                        disabled={!transactionID}
                                        icon={<BranchesOutlined />} onClick={()=>transactionID && setCurrentStep(2)}/>
                        </Steps>

                        <IfEqual expect={0} actual={currentStep}>
                            <Typography>
                                <Typography.Title>
                                    Enter Signed Testnet Transaction
                                </Typography.Title>
                                <Typography.Paragraph>
                                    Paste a hex-encoded, signed testnet transaction to try the defender.
                                    <br/>
                                    Your defender will be active for 1 hour.
                                </Typography.Paragraph>

                            </Typography>

                            <TextArea rows={4}
                                      placeholder="Enter hex-encoded transaction here..."
                                      value={val}
                                      onChange={(e) => setVal(e.target.value)}/>
                            <Button loading={isLoading} type="primary" onClick={defend} style={{marginTop: 10, marginBottom: 10}}>
                                Defend
                            </Button>

                            <Typography>
                                <h3>What should transaction include?</h3>
                                <Typography.Paragraph>
                                    Your transaction should ideally be spending all funds in your wallet.
                                    These funds should be moved to a separate address you control.
                                    For testing purposes you can send it to another address in the same wallet, but in a
                                    real world
                                    scenario
                                    you'll want to send your funds to a separate wallet that was not compromised
                                </Typography.Paragraph>
                                <h3>How high should the fee be?</h3>
                                <Typography.Paragraph>
                                    The fee on the transaction needs to be higher than the fee the attacker is spending.
                                </Typography.Paragraph>
                                <h3>Is there a way to be more intelligent with the fee selection?</h3>
                                <Typography.Paragraph>
                                    Yes! We offer a countermeasures feature that allows you to include transactions with higher fees that we intelligently select<br/>
                                    This is a paid only feature
                                </Typography.Paragraph>

                                <h3>Should I Broadcast this transaction now?</h3>
                                <Typography.Paragraph>
                                    No! The provided transaction will only be broadcast when we detect someone spending
                                    your funds.
                                    If you broadcast the transaction you'll just be moving your funds unnecessarily.
                                </Typography.Paragraph>

                                <h3>Can you guarantee that my transaction will beat the attackers?</h3>
                                <Typography.Paragraph>
                                    No we cannot guarantee that the provided transaction will beat the attacker's transaction simply due to the nature of the
                                    underlying block chain protocol.<br/>
                                    We employ sophisticated measures to significantly increase the probability of beating the attacker.
                                </Typography.Paragraph>
                            </Typography>
                        </IfEqual>

                        <IfEqual expect={1} actual={currentStep}>
                            <Typography>
                                <Typography.Title>
                                    Simulate an Attacker
                                </Typography.Title>
                                <Typography.Paragraph>
                                    Now create a separate transaction spending some or all of the funds from your
                                    wallet.
                                    Ideally pick a fee that is lower than the fee you allocated in your defense
                                    transaction
                                </Typography.Paragraph>

                                <h3>Should I save the transaction ID from the attack?</h3>
                                <Typography.Paragraph>
                                    Yes, you'll want to save the transaction ID from the transaction you broadcast to see how it fared against the defender.
                                </Typography.Paragraph>
                            </Typography>

                            <Button
                                icon={<RightOutlined/>}
                                onClick={() => setCurrentStep(2)}>
                                Click here once you've broadcast the transaction</Button>
                        </IfEqual>

                        <IfEqual expect={2} actual={currentStep}>
                            <Typography>
                            <Typography.Title>
                                    Verify
                                </Typography.Title>
                                <Typography.Paragraph>
                                    If you successfully broadcast the attack transaction the defender should've
                                    activated.
                                </Typography.Paragraph>

                                <Button icon={<EyeOutlined/>}
                                        target={'_blank'} href={transactionID}>View Transaction</Button>
                                <h3 style={{marginTop: 10}}>I don't see the transaction</h3>
                                <Typography.Paragraph>
                                    You may need to wait a few seconds before the transaction shows up. If it does not it could mean that the other transaction worked.
                                    Try searching for the attacker's transaction ID to see the status of it
                                </Typography.Paragraph>
                            </Typography>
                        </IfEqual>
                    </Content>
                    </Badge.Ribbon>
                </Col>
            </Row>
    )
}

export {PublicDefenderPage}
